// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mfhdaiymdtwhsnaximji.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1maGRhaXltZHR3aHNuYXhpbWppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0ODQzNjUsImV4cCI6MjA4Njg0NDM2NX0.UloyeIuKEl9ifihIQPPJLA9coc_WqULzIdsJtzv8YN4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});